// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__Ez1SW","buttonFullWidth":"Button_buttonFullWidth__m291m"};